/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfAccountingV1ManualEntryState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_ACCOUNTING_V1_MANUAL_ENTRY_STATE_ENTITY_NAME = 'ixf.accounting.v1.ManualEntry';
export const ixfAccountingV1ManualEntryStateEntity = new schema.Entity<IxfAccountingV1ManualEntryState>(IXF_ACCOUNTING_V1_MANUAL_ENTRY_STATE_ENTITY_NAME, {}, { idAttribute: 'entryId' });

